<template>
  <v-container
    class="findings-form-level-one-container mx-0"
    :class="[getFindingOneClass()]"
    grid-list-lg
  >
    <v-layout row wrap>
      <v-flex xs6 class="vuetify-fz fz-42">
        <v-select
          v-if="finding.questions.finding"
          hide-details
          placeholder="Finding"
          :items="findingOptionItems"
          :value="finding.questions.finding.value"
          :class="[getFocusClass('finding')]"
          :label="$t('finding')"
          @change="$emit('change', { field: 'finding', newValue: $event })"
        ></v-select>
      </v-flex>
      <v-flex xs2 align-self-end class="vuetify-fz fz-42 tac">
        <FindingNumberInput
          v-if="isNumberInputShow"
          :finding="finding"
          :class="['input-container', getFocusClass('number')]"
          @change="$emit('change', $event)"
        />
      </v-flex>
      <v-flex xs4 align-self-end v-if="isTakeNoteOfInputShow">
        <TakeNoteInput
          :options="takeNoteOptionItems"
          :value="finding.questions.takeNote.value"
          :getFocusClass="getFocusClass"
          class="vuetify-fz fz-42"
          @change="$emit('change', $event)"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { findMatchI18n } from '@/utils/findMatchI18n'
import FindingNumberInput from "@/components/examinations/FindingNumberInput.vue";
import TakeNoteInput from "@/components/examinations/TakeNoteInput.vue";
export default {
  name: 'PreviewFindingsFormLevelOne',

  props: {
    findingIndex: Number,
    finding: Object,
    questions: Object,
    hiddenParams: {
      required: false,
      type: Object,
    },
    isExamination: Boolean,
  },

  data() {
    return {}
  },

  components: {
    FindingNumberInput,
    TakeNoteInput
  },

  computed: {
    findingQID() {
      return this.finding.questions.finding.questionID
    },

    takeNoteQID() {
      return this.finding.questions.takeNote.questionID
    },

    isCountableFinding() {
      return this.finding.questions.finding && this.finding.questions.number
    },

    isNumberInputShow() {
      return this.isCountableFinding && this.finding.questions.number
    },

    isTakeNoteOfInputShow() {

      return (
        this.isCountableFinding &&
        this.finding.questions &&
        this.finding.questions.number &&
        Number(this.finding.questions.number.value) > 1 &&
        this.questions[this.findingQID].options
      )
    },

    findingOptionItems() {
      console.log('findingOptionItems locale', this.$i18n.locale)
      const locale = this.$i18n.locale
      const qID = this.findingQID
      const options = this.questions[qID].options

      let temp_options = []
      let temp_obj = {}
      const specialHandelText = { "colon maltoma": "Colon MALToma" }
      for (let key in options) {
        temp_options.push(options[key])
        const _text =specialHandelText[options[key]] || options[key].charAt(0).toUpperCase() + options[key].slice(1)
        temp_obj[options[key]] = {
          value: key,
          text: this.transI18n(_text),
        }
      }
      temp_options.sort()

      let arr = []
      for (let i in temp_options) {
        arr.push(temp_obj[temp_options[i]])
      }

      return arr
    },

    takeNoteOptionItems() {
      const qID = this.takeNoteQID
      const options = this.questions[qID].options

      let arr = []

      for (const key in options) {
        arr.push({
          value: key,
          text: this.transI18n(options[key]),
        })
      }

      return arr
    },
  },
  methods: {
    getFocusClass(key) {
      if (this.hiddenParams) {
        return this.hiddenParams.focus == key ? 'focus' : ''
      } else {
        return ''
      }
    },
    getFindingOneClass() {
      if (this.isExamination) return 'is-examination'
    },
    transI18n(text) {
      return findMatchI18n(text)
    },
  },
}
</script>
